import React from 'react';
import { CustomToolTip } from 'shared-one-ux-components';

export default function StepTwo({ state = {} }) {
	const {
		clientName,
		product,
		useCaseName,
	} = state;
	return (<div className="mt-8" style={{ height: '34rem' }}>
		<div className="text-heading-05 font-bold mb-4">Review summary</div>
		<div className="text-body-02 mb-8">
			Take a moment to confirm your selections before generating your
			project.
		</div>

		<div>
			<section className="items-center justify-center h-full"
				style={{ maxWidth: '60rem' }}>
				<div className="flex flex-col">
					<div className="flex flex-row pb-6">
						<div className="order-1 w-1/4">
							<label className="text-heading-02 font-bold">Client
								name</label>
						</div>
						<div className="order-2 w-2/4 capitalize">
							<div><CustomToolTip text={clientName} startEllipsisLen="51"
								width="100%" enableBoldFont={false} />
							</div>
						</div>
					</div>
					<div className="flex flex-row pb-6">
						<div className="order-1 w-1/4">
							<label className="text-heading-02 font-bold">ADP
								product</label>
						</div>
						<div className="order-2 w-2/4">
							<span className="capitalize">{product}</span>
						</div>
					</div>
					<div className="flex flex-row pb-6">
						<div className="order-1 w-1/4">
							<label className="text-heading-02 font-bold">Use case</label>
						</div>
						<div className="order-2 w-2/4">
							<span className="capitalize">{useCaseName}</span>
						</div>
					</div>
					<div className="flex flex-row py-4">
						If you need to change the use case, select the back button; otherwise,
						generate project to continue.
					</div>
				</div>
			</section>
		</div>
	</div>);
}
